import { render, staticRenderFns } from "./OrderInfoBar.vue?vue&type=template&id=9b1d1de8&"
import script from "./OrderInfoBar.vue?vue&type=script&lang=js&"
export * from "./OrderInfoBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports